import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const HomeRedirector = () => {
  const { user, userType, loading } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (userType === 'guardian') {
    return <Navigate to="/guardian" replace />;
  }

  // Default child route
  return <Navigate to="/dashboard" replace />;
};

export default HomeRedirector;
